import { api } from 'app/utils/api/helpers'

export const updateVacateAndAvailabilityDates = (offerGUID, payload) => {
  return api.put(`/sm/offers/${offerGUID}/availability`, payload)
}
